// src/app/routes/race.$id.tsx
import { useLoaderData } from "react-router";
import {getRaceWithParticipants} from "@rennpuls/backend/domain/race/getRace";
import {RaceDetail} from "@rennpuls/components/races/detail/raceDetail";
import {wrapLoader} from "@/lib/wrap-loader";

type LoaderData = {
    race: NonNullable<Awaited<ReturnType<typeof getRaceWithParticipants>>>;
};

export const loader = wrapLoader(async ({params}) => {
    const race = await getRaceWithParticipants(params.id!);
    if (!race) {
        throw new Response("Not Found", {status: 404});
    }
    return {race}
});

// src/app/routes/race.$id.tsx
export default function RaceDetailPage() {
    const {race} = useLoaderData<LoaderData>();

    return (
        <div>
            <RaceDetail race={race}/>
        </div>

    );
}
